module.exports = __webpack_public_path__ + "img/plants.062180de.jpg";